import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SponsoredBrandStatsMain from './components/SponsoredBrandStatsMain';

const SponsoredBrandStatsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Sponsored Brand Stats</h3>
      </Col>
    </Row>
    <Row>
      <SponsoredBrandStatsMain />
    </Row>
  </Container>
);

export default SponsoredBrandStatsPage;
